<template>
    <transition name="fade">
        <div class="row justify-content-center">
            <div class="col-lg-10 col-md-12 col-sm-12">
                <!-- <div class="callout callout-info"> -->
                <div class="card card-body">
                    <!-- <p class="bold fs-18">With BIR-Filed Financial Statement</p> -->
                    <div class="table-responsive text-center table-middle">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th style="min-width: 120px;">Number of Employees <em>(Max. 40 or DOLE accredited employees, whichever is lower)</em></th>
                                    <th style="min-width: 120px;">Loan Amount per Employee</th>
                                    <th>Service Fee</th>
                                    <th>Grace Period</th>
                                    <th style="min-width: 120px;">Loan Term <em>(Inclusive of grace period)</em></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="nowrap">1 to 40</td>
                                    <td class="nowrap">Php 12,000</td>
                                    <td class="nowrap">4%</td>
                                    <td class="nowrap">0 or 3 months</td>
                                    <td class="nowrap">12 months</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Well done, you may now provide your preferred loan amount</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 alert alert-success2">
                                <!-- <p class="card-text text-justify pb-0 mb-0">Your maximum employees to enroll for 13<sup>th</sup> month pay is <strong>{{formLoan.emp13}}</strong>.</p> -->
                                <p class="card-text text-justify pb-0 mb-0">Your maximum loanable amount is <strong>Php {{formLoan.max_loan | curr}}</strong></p>
                                <em class="card-text text-justify pb-0 mb-0"><strong>Note:</strong> Requested loan amount is subject to assessment and approval by SB Corporation.</em>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>No. of Employee/s</label>

                                    <select class="form-control custom-select-sm" @change="selectedEmp()" v-model="formLoan.avail13" :class="{'is-invalid': $parent.submitting && $v.formLoan.avail13.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option v-for="index in formLoan.emp13" :key="index" :value="index">{{index}}</option>
                                    </select>

                                    <!-- <input type="text" class="form-control form-control-sm" v-model="formLoan.avail13"  :class="{'is-invalid': $parent.submitting && $v.formLoan.avail13.$error}"> -->
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Loan Amount</label>
                                    <input type="text" class="form-control form-control-sm" :value="formLoan.req_loan_amt ? $options.filters.currency(formLoan.req_loan_amt) : null" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Loan Term (in months)</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.req_loan_term" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>
                        <div class="row">


                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Grace Period (in months)</label>
                                    <select class="form-control custom-select-sm" v-model="formLoan.grace_period" :class="{'is-invalid': $parent.submitting && $v.formLoan.grace_period.$error}">
                                        <option :value='null' disabled>- Select -</option>
                                        <option value='0'>0</option>
                                        <option value='3'>3</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Service Fee</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.service_fee" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Payment Mode</label>
                                    <input type="text" class="form-control form-control-sm" v-model="formLoan.monthly='Monthly'" :readonly="readonly" @keydown="handler($event)" @mousedown="handler($event)" @mouseup="handler($event)" @contextmenu="handler($event)">
                                </div>
                            </div>
                        </div>




                        <div v-if="formLoan.req_loan_amt && formLoan.req_loan_amt <= 48000">
                            <hr>
                            <p class="card-text text-justify bold">Share with us some information about your Business Permit</p>
                            <div class="alert alert-info2">
                                <i class="fas fa-info-circle mr-1 fs-15"></i><strong>Note: </strong>This will require you to upload the required documents on Step 4.
                            </div>

                            <p class="card-text text-justify">Choose your available 2021 permit:</p>
                            <div class="row">
                                <div class="col-6 text-center">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="y-q15" value="M" v-model="formLoan.current_permit">
                                        <label for="y-q15" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.current_permit.$error }">Mayor's Permit</label>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="icheck-primary d-inline">
                                        <input type="radio" id="n-q15" value="B" v-model="formLoan.current_permit">
                                        <label for="n-q15" :class="{ 'errorRadio': $parent.submitting && $v.formLoan.current_permit.$error }">Barangay's Permit</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf
    } from 'vuelidate/lib/validators';

    export default {
        props: ['formLoan'],
        data() {
            return {
                readonly: true,
                req_loan_amt: false,
                annual_sale: null,
            }
        },
        validations: {
            formLoan: {
                req_loan_amt: {
                    required
                },
                req_loan_term: {
                    required
                },
                avail13: {
                    required
                },
                grace_period: {
                    required
                },
                current_permit: {
                    required
                },
            },
        },
        created() {
            this.eval13th();
        },
        methods: {
            selectedEmp() {
                // let val = e.target.value;
                this.formLoan.req_loan_amt = this.formLoan.avail13 * 12000;
                if (this.formLoan.req_loan_amt <= 48000) {
                    this.formLoan.current_permit = null;
                }else{
                    this.formLoan.current_permit = 'M';
                }
            },
            eval13th() {
                this.formLoan.service_fee = '4.0%';
                this.formLoan.req_loan_term = '12';
                let max13 = this.formLoan.emp13;
                if (max13 >= 40) {
                    this.formLoan.emp13 = 40;
                    this.formLoan.max_loan = 40 * 12000;
                    if(max13 > 99){
                        this.formLoan.bir = 'Y';
                    }else{
                        this.formLoan.bir = 'N';
                    }
                }
                else{
                    this.formLoan.max_loan = max13 * 12000;
                    this.formLoan.bir = 'N';
                }
            },


            next() {
                this.$parent.submitting = false;
                this.$parent.submitting = true;
                this.$v.formLoan.$touch();
                if (this.$v.formLoan.$invalid) {} else {
                    if (this.formLoan.req_loan_amt >= 150000) {
                        Swal.fire({
                                icon: 'info',
                                html: '<p class="fs-18 mb-0"><b>ISANG PAALALA:</b></p>' +
                                    '<p class="fs-16 mx-n2">Kung sakaling ang inyong aplikasyon ay ganap na maaprubahan, kakailanganin magsumite ng Post Dated Cheques (PDCs) kasama ng iba pang mga requirements at naayon na kundisyones bago pa man tuluyang matanggap ang inyong CARES loan.</p>' +
                                    '<hr><p class="fs-18 mb-0"><b>IMPORTANT NOTICE:</b></p>' +
                                    '<p class="fs-16 mx-n2">(Should your loan application be approved, you shall be required to provide/issue Post Dated Cheques (PDCs) in addition to all other requirements and conditions prior to loan release.)</p>',
                                allowOutsideClick: false,
                                showCancelButton: true,
                                confirmButtonText: 'Continue',
                                cancelButtonText: 'Cancel',
                                reverseButtons: true
                            })
                            .then((result) => {
                                if (result.isConfirmed) {
                                    this.$emit('next');
                                }
                            });
                    } else {
                        this.$emit('next');
                    }
                }
            },
            thousands_separators(num) {
                if (num) {
                    let num_parts = num.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return num_parts.join(".");
                }
            },
            checkLoanAmount() {
                let val = this.formLoan.req_loan_amt;
                let loanAmount = this.formLoan.req_loan_amt * 1;
                let maxLoan = this.formLoan.max_loan;
                let amount = this.thousands_separators(maxLoan.toFixed(2));
                if (loanAmount) {
                    if (loanAmount < 10000) {
                        Swal.fire({
                            icon: 'info',
                            title: 'Reminder',
                            html: `Minimum Loan: <b>Php 10,000</b>`,
                            allowOutsideClick: false
                        }).then((response) => {
                            this.formLoan.req_loan_amt = null;

                        })
                    } else {
                        if (loanAmount > maxLoan) {
                            Swal.fire({
                                icon: 'info',
                                title: 'Reminder',
                                html: `Maximum Loan: <b>Php ${amount}</b>`,
                                allowOutsideClick: false
                            }).then((response) => {
                                this.formLoan.req_loan_amt = null;
                            })
                        }
                    }
                } else {}

            },

            maxNum(e) {
                let val = e.target.value;
                if (e.keyCode === 46) { //dot
                    e.preventDefault();
                } else {
                    if (val.length <= 6) {
                        return true;
                    } else e.preventDefault();
                }
            },
            handler($event) {
                if (this.readonly) {
                    $event.preventDefault();
                }
            },
        },
        computed: {

        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }


    .table-middle>table>tbody>tr>td {
        vertical-align: middle;
    }

    .table-middle>table>thead>tr>th {
        vertical-align: middle;
    }
</style>